module.exports = __webpack_public_path__ + "ef42f02564de8daf3cd7e33e4fa0d3d2.jpg";